<template>
  <div>
    <globalhead v-on:HomeSearch="search" v-bind:isIndex="isIndex"></globalhead>
    <Index></Index>
    <globalfoot></globalfoot>
  </div>
</template>

<script>
// @ is an alias to /src
import globalhead from "@/components/Global-Head";
import globalfoot from "@/components/Global-Foot";
import Index from "@/components/Index";
import axios from "axios";
import $ from "jquery";

export default {
  data() {
    return {
      search: "",
      isIndex: true
    };
  },
  methods: {},
  async mounted() {
    //this.$router.push("/login");
  },
  components: {
    globalhead,
    globalfoot,
    Index
  }
};
</script>
<style>
.home {
  display: flex;
  flex-direction: column;
}
</style>

